import React from 'react';
import GitHubCalendar from 'react-github-calendar';

const GitHubContributionsCalendar = ({ username }) => {
  const [isDark, setIsDark] = React.useState(false);

  React.useEffect(() => {
    const checkTheme = () => {
      setIsDark(document.documentElement.classList.contains('dark'));
    };
    checkTheme();
    // Listen for theme changes
    const observer = new MutationObserver(checkTheme);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });
    return () => observer.disconnect();
  }, []);

  const lightTheme = {
    light: ['#ebedf0', '#c6e48b', '#7bc96f', '#239a3b', '#196127']
  };

  const darkTheme = {
    dark: ['#161b22', '#0e4429', '#006d32', '#26a641', '#39d353'] // GitHub dark theme colors
  };

  return (
    <div className="hidden lg:block"> {/* Hide on screens smaller than lg */}
      <div className="flex justify-center items-center">
        <div className="bg-white dark:bg-gray-900 p-4 lg:p-8 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700">
          <h2 className="text-lg lg:text-2xl font-bold text-gray-800 dark:text-white mb-4">GitHub Contributions Calendar</h2>
          <GitHubCalendar
            username={username}
            blockMargin={4}
            blockRadius={2}
            blockSize={15} // Adjust block size for smaller screens
            colorScheme={isDark ? "dark" : "light"}
            fontSize={12} // Adjust font size for smaller screens
            hideColorLegend={false}
            hideMonthLabels={false}
            hideTotalCount={false}
            loading={false}
            showWeekdayLabels={false}
            style={{ marginBottom: '1rem', maxWidth: '100%' }} // Make sure calendar doesn't overflow on small screens
            theme={isDark ? darkTheme : lightTheme}
            throwOnError={false}
            weekStart={0}
          />
          <p className="text-gray-800 dark:text-white text-sm lg:text-base">
            Made with love by <a href={`https://github.com/${username}`}  target="_blank" rel="noopener noreferrer" className="font-bold underline text-blue-600 dark:text-blue-400">@{username}</a> ❤️
          </p>
        </div>
      </div>
    </div>
  );
}

export default GitHubContributionsCalendar;
